module.exports = __webpack_public_path__ + "img/harris-profile.16c146dd.png";